import React from "react";
import ClientSelectableItem from "./ClientSelectableItem.jsx";
import { EmptyState } from "./ResultsPrimitives.jsx";
import { getFleetProductTone } from "../utils/cropColors.js";

// Onglet plein au début de chaque série d'un même produit, comme dans le Gantt.
function StepProductRunTab({ label }) {
  const { accentColor } = getFleetProductTone(label);
  return (
    <span
      className="-mb-1 ml-px w-fit rounded-t-[4px] px-1.5 pt-0.5 pb-px text-[0.6rem] font-extrabold uppercase leading-[1.2] tracking-[0.04em] text-white"
      data-assignment-step-product={label}
      style={{ backgroundColor: accentColor }}
    >
      {label}
    </span>
  );
}

export default function OperationalStepList({ interactions = {}, servicePercentByStepKey = null, steps = [] }) {
  const resolvedSteps = Array.isArray(steps) ? steps.filter(Boolean) : [];

  return (
    <div className="grid gap-1" data-assignment-operational-step-list>
      {resolvedSteps.length ? (
        resolvedSteps.map((step, index) => {
          const productLabel = step.grainType || "";
          const startsProductRun = Boolean(productLabel) && productLabel !== (resolvedSteps[index - 1]?.grainType || "");
          return (
            <React.Fragment key={step.key}>
              {startsProductRun ? <StepProductRunTab label={productLabel} /> : null}
              <ClientSelectableItem
                interactions={interactions}
                servicePercent={servicePercentByStepKey?.get(`${step.tripId}::${step.displaySequence}`) ?? 0}
                startsProductRun={startsProductRun}
                step={step}
              />
            </React.Fragment>
          );
        })
      ) : (
        <EmptyState message="Aucune étape opérationnelle sur ce camion pour l'instant." />
      )}
    </div>
  );
}
